// extracted by mini-css-extract-plugin
export var layoutContainer = "_3t-0";
export var layoutContainerOpen = "_3t-3";
export var mainContent = "_3t-1";
export var panelLarge = "_3t-6";
export var panelMedium = "_3t-5";
export var panelSmall = "_3t-4";
export var slidePanel = "_3t-2";